








































































/**
 * @copyright       Palace Resorts
 * @description     Pantalla modal edit
 */
import i18nMessages from "./i18n/messages";
import dataService from "@/services/proveedoresAPI";
import ResponseData from "@/models/store/ProveedoresTypesData";
import GlobalMixin from "@/mixins/global";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  props: {
    dialog: { type: Boolean, default: false },
    proveedor: { type: Object, default: {} },
    registroActividadesEdit: { type: Object, default: {} },
    docuementoSeccion: { type: Object, default: {} },
    registroSTPS: { type: Array, default: [] },
  },
  data: () => {
    return {
      // GENERAL
      moduleName: "MODAL_NEW_EDIT",
      menu: false,
      modal: false,
      menu1: false,
      valid: false,
      enabled: false,
      disabled: true,
    };
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    openDialog() {
      this.$emit("openDialog");
    },
    async save() {
      if (this.registroActividadesEdit.registroActividadID) {
        // Editar
        dataService
          .updateActivities(this.registroActividadesEdit)
          .then((Response: ResponseData) => {
            if (Response.data.data[0]) {
              this.$emit(
                "notificacion",
                "Registro editado correctamente",
                "success"
              );
              this.registroActividadesEdit.registroActividadID =
                Response.data.data[0].id;
              this.registroActividadesEdit.registroActividadEstatusID = 1;

              this.$emit("saveItem");
            } else {
              this.$emit(
                "notificacion",
                "No se pudo editar el registro, intente de nuevo más tarde",
                "red darken-2"
              );
            }
          })
          .catch((e: Error) => {
            this.$emit(
              "notificacion",
              "No se pudo editar el registro" + e,
              "red darken-2"
            );
          });
      } else {
        // Crear
        dataService
          .createActivities(this.registroActividadesEdit)
          .then((Response: ResponseData) => {
            if (Response.data.data[0]) {
              this.registroActividadesEdit.registroActividadID =
                Response.data.data[0].id;
              this.registroActividadesEdit.registroActividadEstatusID = 1;
              this.$emit(
                "notificacion",
                "Registro agregado correctamente",
                "success"
              );
              this.$emit("saveItem");
            } else {
              this.$emit(
                "notificacion",
                "No se pudo agregar el registro, intente de nuevo más tarde",
                "red darken-2"
              );
            }
          })
          .catch((e: Error) => {
            this.$emit(
              "notificacion",
              "No se pudo agregar el registro" + e,
              "red darken-2"
            );
          });
      }
    },
  },
});
